import { LOGO_URL, LOGO_ONBG_URL } from "../lib/brand";

export function Wordmark({ className = "" }) {
  return (
    <img
      src={LOGO_ONBG_URL}
      alt="My Pocket Lender — Powered by LolliPOP"
      data-testid="brand-wordmark"
      className={`h-11 w-auto rounded-lg shadow-lg shadow-black/30 ${className}`}
    />
  );
}

export function LogoImage({ className = "h-40" }) {
  return (
    <div className="inline-flex items-center justify-center rounded-2xl bg-white p-4">
      <img src={LOGO_URL} alt="My Pocket Lender" className={`${className} w-auto object-contain`} />
    </div>
  );
}
